import { rollup } from 'd3'
import { makeXeroLink } from '@local_modules/generic/xero/utilities/xero-links.js'

export function makeColumnDefs (entitiesTrackings) {
  const columnDefs = []

  columnDefs.push({
    field: 'name'
  })

  columnDefs.push({
    headerName: 'Xero',
    valueGetter: function (cellParams) {
      return makeXeroLink('Trackings', { shortCode: cellParams.data.xero_shortcode })
    },
    cellRenderer: function (cellParams) {
      return '<a href="' + cellParams.value + '" target="_blank">Open</a>'
    }
  })

  const trackingsCategoryColumns = makeTrackingsCategoryColumns(entitiesTrackings)
  columnDefs.push(...trackingsCategoryColumns)

  return columnDefs
}

function makeTrackingsCategoryColumns (entitiesTrackings) {
  const columnDefs = []

  const trackingsMap = rollup(entitiesTrackings,
    (values) => {
      return {
        groupValues: values,
        category: {
          id: values[0].category_id,
          name: values[0].category_name
        },
        accountingOrganisation: {
          id: values[0].accounting_organisation_id
        }
      }
    },
    (d) => d.category_name,
    (d) => d.accounting_organisation_id
  )

  trackingsMap.forEach((value, mapKeyCategoryName) => {
    columnDefs.push({
      headerName: mapKeyCategoryName,
      valueGetter: function (cellParams) {
        const entityCategory = cellParams.data.entityTrackingsMap?.get(mapKeyCategoryName)
        if (!entityCategory) return null

        if (entityCategory.category.status === 'ARCHIVED') return 'Archived'

        const numberActiveOptions = entityCategory.categoryOptions.filter(v => v.option_status === 'ACTIVE').length
        return `${numberActiveOptions} Options`
      },
      cellRenderer: function (cellParams) {
        if (cellParams.value === 'Archived') return '<span class="tag is-info is-light is-small">Archived</span>'
        return cellParams.value
      },
      context: {
        categoryName: mapKeyCategoryName
      }
    })
  })

  columnDefs.sort((a, b) => {
    return a.headerName.localeCompare(b.headerName)
  })

  return columnDefs
}
